import styled from 'styled-components';

function VideoTableHeader() {
  return (
    <Row>
      <Cell>No</Cell>
      <Cell flex='5' leftArrange>
        자료명
      </Cell>
      <Cell>게시일</Cell>
      <Cell flex='2'>미리보기</Cell>
      <Cell>재생</Cell>
      <Cell>삭제</Cell>
      <Cell />
    </Row>
  );
}

const Row = styled.div`
  width: 100%;
  display: flex;
  background-color: #ffffff;
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
`;
const Cell = styled.div<{ flex?: string; leftArrange?: boolean }>`
  display: flex;
  flex: ${(props) => props.flex || 1};
  align-items: center;
  padding: 0 20px;
  height: 48px;
  border-bottom: 1px solid #cbccce;
  justify-content: ${(props) => (props.leftArrange ? 'flex-start' : 'center')};
  color: ${(props) => props.theme.mono[65]};
  font-weight: 600;
`;
export default VideoTableHeader;
